import { SelectItem, TreeNode } from 'primeng/api';

export class QuestionBase<T> {
  value: T | undefined;
  key: string;
  label: string;
  required: boolean;
  order: number;
  controlType: string;
  type: string;
  options: SelectItem[];
  icon: string;
  treeOptions: TreeNode[];
  filter: boolean;
  help: string;
  visibility: string;
  className: string;
  isImage: boolean;
  filetype:string;
  fileLinks:any;
  format:string;
  disable?:boolean;
  selectionMode : string;
  valueShow: any;
  showTime:boolean;
  touchUI : boolean;
  function?: (() => void);

  constructor(
    options: {
      value?: T | any;
      valueShow?: T | any;
      key?: string;
      label?: string;
      required?: boolean;
      order?: number;
      controlType?: string;
      type?: string;
      options?: SelectItem[] | any[];
      icon?: string;
      treeOptions?: TreeNode[];
      filter?: boolean;
      help?: string;
      visibility?: string;
      className?: string;
      isImage?: boolean;
      filetype?:string;
      fileLinks?:any;
      format?:string;
      disable?:boolean;
      selectionMode?:string
      showTime?: boolean;
      touchUI?:boolean;
      function?: () => void;
    } = {}
  ) {
    this.value = options.value;
    this.valueShow = options.valueShow || '';
    this.key = options.key || '';
    this.label = options.label || '';
    this.required = !!options.required;
    this.order = options.order === undefined ? 1 : options.order;
    this.controlType = options.controlType || '';
    this.type = options.type || '';
    this.options = options.options || [];
    this.icon = options.icon || '';
    this.treeOptions = options.treeOptions || [];
    this.filter = !!options.filter;
    this.help = options.help || '';
    this.visibility = options.visibility || 'true';
    this.className = options.className || 'col-md-4 col-sm-6 col-12';
    this.isImage = options.isImage || false;
    this.filetype = options.filetype || "ORGANIZATIONAL_UNIT";
    this.fileLinks = options.fileLinks || {};
    this.format = options.format || '';
    this.disable = options.disable || false;
    this.selectionMode = options.selectionMode || 'single';
    this.showTime = !!options.showTime;
    this.touchUI = !!options.touchUI;
    this.function = options.function || undefined;
  }
}

/*
  Copyright Google LLC. All Rights Reserved.
  Use of this source code is governed by an MIT-style license that
  can be found in the LICENSE file at https://angular.io/license
  */
